import { useCallback, useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { MDXProvider } from '@mdx-js/react'

import Sidebar from './Sidebar'
import MobileTopBar from './MobileTopBar'
import SearchModal from './SearchModal'
import { mdxComponents } from '../mdx'

export default function Layout() {
  // Drawer state only matters on mobile — desktop CSS pins the sidebar in
  // place. Defaulting to `false` matches SSR output and avoids a flash of an
  // open drawer on slow connections.
  const [drawerOpen, setDrawerOpen] = useState(false)
  const openDrawer = useCallback(() => setDrawerOpen(true), [])
  const closeDrawer = useCallback(() => setDrawerOpen(false), [])

  // Close the drawer whenever the route changes (covers same-link taps too,
  // because react-router still emits a location event for those).
  const location = useLocation()
  useEffect(() => {
    setDrawerOpen(false)
  }, [location.pathname])

  // Esc closes the drawer; the search modal owns its own Esc handling.
  useEffect(() => {
    if (!drawerOpen) return
    function onKey(e: KeyboardEvent): void {
      if (e.key === 'Escape') setDrawerOpen(false)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [drawerOpen])

  // Lock background scroll while the mobile drawer is open.
  useEffect(() => {
    if (!drawerOpen) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [drawerOpen])

  return (
    <MDXProvider components={mdxComponents}>
      <div className={drawerOpen ? 'help-shell drawer-open' : 'help-shell'}>
        <MobileTopBar onMenuClick={openDrawer} />
        <Sidebar open={drawerOpen} onNavigate={closeDrawer} />
        <div
          className={drawerOpen ? 'help-scrim is-visible' : 'help-scrim'}
          onClick={closeDrawer}
          aria-hidden
        />
        <main className="help-content">
          <div className="help-content-inner">
            <Outlet />
          </div>
        </main>
        <SearchModal />
      </div>
    </MDXProvider>
  )
}
